import { cn } from '@/lib/utils';

interface Props {
  baseBranch: string;
  className?: string;
}

function channelLabel(baseBranch: string): string {
  return baseBranch === 'main' ? 'production' : baseBranch;
}

export function ChannelBadge({ baseBranch, className }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-[10px] uppercase tracking-wide text-muted-foreground',
        className,
      )}
      title={`Will publish to ${channelLabel(baseBranch)}`}
    >
      → {channelLabel(baseBranch)}
    </span>
  );
}
